<script>

    import HomeAnimation from 'home';
    import bowser from 'bowser';

    export default {

        name: 'HomeAnimationComponent',

        data() {
            return {
                homeAnimation: null,
                isMobile: false,

                elements: {
                    canvasEl: null,
                    newsEl: null,
                },

                isIEOrEdge: false,
                isWindows: false,

                showHomeNavigation: false,

                styles: {
                    homeNews: {
                        // paddingLeft: 0,
                        width: 0,
                        opacity: 0,
                    },
                    canvas: {
                        // marginLeft: 0,
                        marginTop: 0,
                    },
                },
            };
        },

        props: [
            'initialColor',
        ],

        mounted() {
            this.homeAnimation = new HomeAnimation();
            this.homeAnimation.init(this.initialColor);

            this.initElements();

            window.addEventListener('resize', this.calculateNavAndNewsSytles);

            // const browser = bowser.getParser(window.navigator.userAgent);
            const browser = bowser.getParser(window.navigator.userAgent);
            const parsedBrowser = browser.parse();
            // console.log(parsedBrowser.parsedResult.os.name);

            // this.isIEOrEdge = (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent)
            //     || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent));
            this.isWindows = parsedBrowser.parsedResult.os.name.toLowerCase() === 'windows';

            // console.log(parsedBrowser.parsedResult.os.name.toLowerCase());

            setTimeout(() => {
                this.calculateNavAndNewsSytles();
                this.animateIn();
            }, 1500);

        },

        beforeDestroy() {
            this.homeAnimation.destroy();
            this.homeAnimation = null;
            window.removeEventListener('resize', this.calculateNavAndNewsSytles);
        },

        methods: {
            initElements() {
                this.elements = {
                    canvasEl: document.querySelector('.canvasContainers'),
                    // newsEl: document.querySelector('.homeNews'),
                };
            },

            animateIn() {
                const canvasElement = document.querySelector('.threeCanvas');
                canvasElement.classList.add('animate');
                this.showHomeNavigation = true;
                this.homeAnimation.triangleIntro();
            },

            calculateNavAndNewsSytles() {
                this.$nextTick(() => {
                    const isMobile = window.matchMedia('(max-width: 740px)');
                    this.isMobile = isMobile.matches;

                    const {canvasEl /* , newsEl */} = this.elements;
                    const canvasWidth = canvasEl.clientWidth;
                    // const newsWidth = newsEl.clientWidth;
                    const canvasPadding = canvasWidth * 0.128;
                    // console.log(canvasWidth, newsWidth);

                    this.styles = {
                        homeNews: {
                            // paddingLeft: (this.isMobile)
                            //     ? canvasWidth - newsWidth - canvasPadding - 10
                            //     : canvasWidth - newsWidth - (2 * canvasPadding),
                            width: canvasWidth - (canvasPadding * 2),
                            opacity: 1,
                        },
                        canvas: {
                            marginTop: -40 - canvasPadding,
                            // marginLeft: (this.isMobile) ? 0 : 179 - canvasPadding,
                        },
                    };

                });
            },

            setHomeAnimationState(state) {
                this.$store.commit('setHomeAnimationState', state);
            },
        },

        computed: {
            homeAnimationState() {
                return this.$store.state.homeAnimationState;
            },
            homeNewsStyle() {
                return {
                    // paddingLeft: `${this.styles.homeNews.paddingLeft.toFixed()}px`,
                    width: `${this.styles.homeNews.width.toFixed()}px`,
                    opacity: this.styles.homeNews.opacity,
                };
            },
        },

        watch: {
            homeAnimationState() {
                if (this.homeAnimation !== null) {
                    this.homeAnimation.transition(this.homeAnimationState);
                    this.homeAnimation.transitionFirst();
                }
            },
            'styles.canvas.marginTop': function (newValue) {
                this.elements.canvasEl.style.marginTop = `${newValue.toFixed()}px`;
            },
            // 'styles.canvas.marginLeft': function (newValue) {
            //     this.elements.canvasEl.style.marginLeft = `${newValue.toFixed()}px`;
            // },
        },

    };

</script>

